/* eslint-disable no-undef */
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueCharts from 'vue-charts'
import VueCarousel from 'vue-carousel'
import SocialSharing from 'vue-social-sharing'
import VueClipboard from 'vue-clipboard2'
import VTooltip from 'v-tooltip'
import InfiniteScroll from 'v-infinite-scroll'
import VueCookie from 'vue-cookie'
import Toasted from 'vue-toasted'
import VueMask from 'v-mask'

Vue.use(VTooltip, {popover: {defaultBaseClass: 'popover-new-container'}})
Vue.use(Toasted, {singleton: true})
Vue.use(VueCookie)
Vue.use(SocialSharing)
Vue.use(VueRouter)
Vue.use(VueCharts)
Vue.use(VueCarousel)
Vue.use(VueClipboard)
Vue.use(InfiniteScroll)
Vue.use(VueMask)
Vue.config.productionTip = true
Vue.templateCache = false

axios.interceptors.request.use((config) => {
  const hasToken = !!localStorage.auth_token

  if (hasToken) {
    config.headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + localStorage.auth_token,
      'Current-Business-Slug': localStorage.org_slug
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response && error.response.status === 401 && error.response.data && error.response.data.restrictLogin) {
    window.location = '/login?sessionExpired=true' + (error.response.data.isSuspended ? '&isSuspended=true' : '')
  } else if (error.response.data.success === false && error.response.data.line !== undefined && error.response.data.file !== undefined) {
    if (localStorage.is_admin_menu_active === 'true' && localStorage.is_hp_admin === 'true') {
      error.response.data['showDetailed'] = true
    } else {
      error.response.data['message'] = 'Something went wrong. Please try again later.'
      error.response.data['showDetailed'] = false
    }
    // exception(error.response.data) // Uncomment this line, if want to display Error strip
    flash(error.response.data.message, 'is-danger') // Replaced flash error with strip API error
  } else {
    return Promise.reject(error)
  }
})

axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = process.env.API_URL

window.events = new Vue()

/**
 * Emits the flash event for the flash message component to handle
 * @param {text} message api response message to flash
 * @param {text} css depending on http response from server ie. 200/400 use css style of choice to depict success/not
 * @param {boolean} hideCloseBtn flag to hide close btn - translating to flash message persisting on page and not
 * @param {integer} duration flag to set duration for display
 * disappearing on settimeout expiry
 * @returns {void}
 */
window.flash = (message, css, hideCloseBtn = false, duration = 0) => {
  window.events.$emit('flash', message, css, hideCloseBtn, duration)
}

/**
 * Emits the exception event for the exception message component to handle
 * @param {Object} exceptionData Exception data object
 * @returns {void}
 */
window.exception = (exceptionData) => {
  window.events.$emit('exception', exceptionData)
}

/**
 * Triggers the closure of a flash message
 * @returns {void}
 */
window.closeFlash = () => {
  window.events.$emit('closeFlash')
}

/**
 * Emits the modal event for the modal component to handle
 * @param {object} props an object of properties for modal to use for dynamic rendering of modal elements
 * @returns {void}
 */
window.modal = (props) => {
  window.events.$emit('modal', props)
}



// WEBPACK FOOTER //
// ./src/bootstrap.js